import usernameLib from '../username'

/**
 * Check whether the user should be allowed to enter the room. If the user is a presenter, check the number of presenters.
 * @param presenterCount The number of presenters currently in the room including the localParticipant
 * @param maxPresenters The maximum number of presenters
 * @param localIdentity The identity of the user from the Twilio Room/Token
 */
export default function (presenterCount: number, maxPresenters: number, localIdentity: string): boolean {

  if (!usernameLib.isPresenter(localIdentity)) return true

  return presenterCount < maxPresenters

}
